import { render, staticRenderFns } from "./jnrclh.vue?vue&type=template&id=effde3e0&scoped=true&"
import script from "./jnrclh.vue?vue&type=script&lang=js&"
export * from "./jnrclh.vue?vue&type=script&lang=js&"
import style0 from "./jnrclh.vue?vue&type=style&index=0&id=effde3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effde3e0",
  null
  
)

export default component.exports